import { css } from "@linaria/core";
import { makeSurfaceToken, postloadedImageSelectors, units } from "@pm2/compat";

export const linkSurface = makeSurfaceToken("--slider-link", {
  color: "255 255 255",
  background: "0 0 0 / 0.8",
});

export const root = css`
  width: 100%;
`;

export const imageWrapper = css`
  position: relative;
`;

export const imageCls = css`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  & ${postloadedImageSelectors.image()} {
    object-fit: contain;
  }
`;

export const link = css`
  position: absolute;
  right: ${units.px(10)};
  bottom: ${units.px(10)};

  padding: 0 ${units.px(10)};

  height: ${units.px(3 * 10)};

  background: ${linkSurface()};
  border-radius: ${units.px(1.5 * 10)};

  font-size: ${units.font.px(1.6 * 10)};
  line-height: ${units.px(3 * 10)};

  &:hover {
    text-decoration: underline;
  }
`;
